import { Button } from '@simplywallst/ui-core';

interface Props {
  hasUserDefinedNarrative: boolean;
  onboardingCompleted: boolean;
  showingOnboarding: () => void;
  editNarrative: () => void;
  createNarrative: () => void;
  isDisabled: boolean;
}

export const NarrativeBuildFlow = ({
  hasUserDefinedNarrative,
  onboardingCompleted,
  showingOnboarding,
  editNarrative,
  createNarrative,
  isDisabled,
}: Props) => {
  if (hasUserDefinedNarrative) {
    return (
      <Button
        styleType="loudLarge"
        onClick={editNarrative}
        disabled={isDisabled}
      >
        Edit Narrative
      </Button>
    );
  }

  return (
    <Button
      styleType="loudLarge"
      onClick={(event) => {
        if (onboardingCompleted) {
          event.preventDefault();
          event.stopPropagation();
          createNarrative();
        } else {
          showingOnboarding();
        }
      }}
    >
      Build Narrative
    </Button>
  );
};
